import React from "react";
import * as Mui from "@mui/material";

export default function ShiftDetailsRow({
  attendanceDetails,
  departmentShiftDetails,
  handleShiftName,
  updateShiftBasedOnRange,
  showAutoComplete,
  themes,
}) {
  return (
    <Mui.Grid
      container
      sx={{
        backgroundColor: attendanceDetails?.is_week_off
          ? attendanceDetails?.week_off_color
          : attendanceDetails?.is_holiday
          ? attendanceDetails?.holiday_color
          : themes?.paleGray,
        mt: showAutoComplete ? 0 : 1,
        borderRadius: 2,
        p: 1,
      }}
      alignItems="center"
    >
      <Mui.Grid
        item
        xs={4}
        sx={{ textAlign: showAutoComplete ? "left" : "center" }}
      >
        <Mui.Typography sx={{ fontWeight: 600 }}>Shift Name</Mui.Typography>
        {showAutoComplete ? (
          <Mui.Autocomplete
            disablePortal
            id="combo-box-demo"
            size="small"
            defaultValue={attendanceDetails?.shift_name}
            options={departmentShiftDetails
              ?.filter(
                (obj) => obj?.shift_name !== attendanceDetails?.shift_name
              )
              .map((obj) => ({
                ...obj,
                label: obj?.shift_name,
              }))}
            sx={{ width: "100%" }}
            filterOptions={(options, state) => {
              return options?.filter((option) =>
                option?.label
                  ?.toLowerCase()
                  ?.includes(state.inputValue.toLowerCase())
              );
            }}
            renderOption={(props, option) => {
              return <li {...props}>{option?.label}</li>;
            }}
            ListboxProps={{
              style: {
                maxHeight: "150px",
              },
            }}
            onChange={(event, value) => {
              handleShiftName(value);
            }}
            onBlur={() => {
              updateShiftBasedOnRange();
            }}
            renderInput={(params) => (
              <Mui.TextField
                {...params}
                placeholder="Select the shift"
                size="small"
              />
            )}
          />
        ) : (
          <Mui.Typography sx={{ mt: 0.7 }}>
            {attendanceDetails?.shift_name}
          </Mui.Typography>
        )}
      </Mui.Grid>

      <Mui.Grid item xs={4} sx={{ textAlign: "center" }}>
        <Mui.Typography sx={{ fontWeight: 600 }}>Shift Time</Mui.Typography>
        <Mui.Typography sx={{ mt: 0.7 }}>
          {attendanceDetails?.shift_start} {" to "}{" "}
          {attendanceDetails?.shift_end}
        </Mui.Typography>
      </Mui.Grid>
      <Mui.Grid item xs={4} sx={{ textAlign: "center" }}>
        <Mui.Typography sx={{ fontWeight: 600 }}>AR Date</Mui.Typography>
        <Mui.Typography sx={{ mt: 0.7 }}>
          {attendanceDetails?.date}
        </Mui.Typography>
      </Mui.Grid>
    </Mui.Grid>
  );
}
